<template>
    <v-col>
      <Breadcrumbs :title="'Products'"></Breadcrumbs>
      <PageTitle :title="'Product Info'" class="pt-3 mx-3"></PageTitle>
      <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-row>
        <div class="col-md-12 col-lg-4">
          <ProductInfo></ProductInfo>
        </div>
        <div class="col-md-12 col-lg-8">
        </div>
      </v-row>
    </v-col>
  </template>

  <script>
  
  import ProductInfo from "@/components/products/ProductInfo";
  import PageTitle from "@/components/shared/PageTitle";  
  import { createNamespacedHelpers } from "vuex";
  const { mapGetters } = createNamespacedHelpers("auth");
  
  export default {
    name: "Products",
    components: {
    ProductInfo,
    PageTitle
},
    data: function () {
      return {
      };
    },
    computed: {
      ...mapGetters({
        loading: "loading",
        profile: "profile"
      })
    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
    },
  
    watch: {
  
    },
  
    methods: {
  
    },
  
  };
  </script>